import type { Box, Node, Rect } from '../types';

/** The node's rectangle in flow space; unmeasured sizes count as 0 (v11). */
export const getNodeRect = (node: Readonly<Node>): Rect => {
  const { x, y } = node.positionAbsolute ?? node.position;
  return { x, y, width: node.width ?? 0, height: node.height ?? 0 };
};

export const rectToBox = ({ x, y, width, height }: Rect): Box => ({ x, y, x2: x + width, y2: y + height });

export const boxToRect = ({ x, y, x2, y2 }: Box): Rect => ({ x, y, width: x2 - x, height: y2 - y });

/** The smallest box containing both boxes. */
export const getBoundsOfBoxes = (a: Box, b: Box): Box => ({
  x: Math.min(a.x, b.x),
  y: Math.min(a.y, b.y),
  x2: Math.max(a.x2, b.x2),
  y2: Math.max(a.y2, b.y2),
});
